import { gql } from "@apollo/client";

export const CREATE_STATIC_DOCUMENT = gql`
  mutation AddStaticDocument($data: StaticDocumentDataInput!) {
    addStaticDocument(data: $data) {
      id
    }
  }
`;

export const UPDATE_STATIC_DOCUMENT = gql`
  mutation UpdateStaticDocument(
    $data: StaticDocumentDataInput!
    $where: StaticDocumentWhereInput!
  ) {
    updateStaticDocument(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_STATIC_DOCUMENT = gql`
  mutation DeleteStaticDocument($where: StaticDocumentWhereInput!) {
    deleteStaticDocument(where: $where) {
      id
    }
  }
`;

const staticDocuments = {
  CREATE_STATIC_DOCUMENT,
  UPDATE_STATIC_DOCUMENT,
  DELETE_STATIC_DOCUMENT,
};

export default staticDocuments;
